export const FIXED_LOGIN_EMAIL = 'hai@reactplus.com'
export const FIXED_LOGIN_PASSWORD = '%?UJbR10&bA5'

export interface SessionUser {
  displayName: string
  email: string
  plan: string
  role: string
  authProvider?: string
}

export const DEFAULT_SESSION_USER: SessionUser = {
  displayName: FIXED_LOGIN_EMAIL,
  email: FIXED_LOGIN_EMAIL,
  plan: 'Pro',
  role: 'user',
}
